import React from 'react';

function EditAttendance() {
  return <div>EditAttendance</div>;
}

export default EditAttendance;
